namespace TabAurous.OMS {
    export interface ProductPartyDetailsForm {
        PartyId: Serenity.ServiceLookupEditor;
        SKU: Serenity.StringEditor;
    }

    export class ProductPartyDetailsForm extends Serenity.PrefixedContext {
        static formKey = 'OMS.ProductPartyDetails';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!ProductPartyDetailsForm.init)  {
                ProductPartyDetailsForm.init = true;

                var s = Serenity;
                var w0 = s.ServiceLookupEditor;
                var w1 = s.StringEditor;

                Q.initFormType(ProductPartyDetailsForm, [
                    'PartyId', w0,
                    'SKU', w1
                ]);
            }
        }
    }
}
